import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import EditOrgLevelsApi from "../../../api/org-levels/EditOrgLevelsApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import ColorPicker from "../../sub/ColorPicker";

function EditOrgLevelModal(props) {
  const [submit, setSubmit] = useState(false);
  const [color, setColor] = useState("");
  const [valuesChanged, setValuesChanged] = useState(false);

  useEffect(() => {
    setColor(props.organization?.color);
  }, [props.organization, props.visible]);

  function handleCancel() {
    props.handleCancel();
    setColor("");
    setSubmit(false);
    setValuesChanged(false);
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditOrgLevelsApi(
      props.organization?.id,
      value.name,
      color
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Level edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit level. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit organizational level"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addOrgLevel"
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        initialValues={{
          order: props.organization?.order,
          name: props.organization?.name,
          color: props.organization?.color,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Order*" name="order">
          <Select disabled placeholder="Select order"></Select>
        </Form.Item>

        <Form.Item
          label="Level name*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter level name!",
            },
          ]}
        >
          <Input placeholder="Level name" />
        </Form.Item>

        <Form.Item label="Color*" name="color">
          <div className="w-20 h-8">
            <ColorPicker
              color={color}
              onChange={(value) => {
                setValuesChanged(true);
                setColor(value);
              }}
            />
          </div>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditOrgLevelModal;
